var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 4.66667L12.0887 12.7613C12.0648 13.0977 11.9143 13.4125 11.6675 13.6424C11.4207 13.8722 11.096 14 10.7587 14H5.24141C4.90417 14 4.57946 13.8722 4.33267 13.6424C4.08588 13.4125 3.93536 13.0977 3.91141 12.7613L3.33341 4.66667M6.66675 7.33333V11.3333M9.33341 7.33333V11.3333M10.0001 4.66667V2.66667C10.0001 2.48986 9.92984 2.32029 9.80482 2.19526C9.6798 2.07024 9.51023 2 9.33341 2H6.66675C6.48994 2 6.32037 2.07024 6.19534 2.19526C6.07032 2.32029 6.00008 2.48986 6.00008 2.66667V4.66667M2.66675 4.66667H13.3334",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashOutline);
export default __webpack_public_path__ + "static/media/TrashOutline.0478c5bab18233625279c70404ffb487.svg";
export { ForwardRef as ReactComponent };